<template>
  <div class="design-page" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="header jc-sb">
      <div class="flex">
        <div style="width: 90px">
          <el-tag type="info" effect="dark" size="medium">{{
            mubanInfo.name
          }}</el-tag>
        </div>
        <div v-for="item in menuList" :key="item.id">
          <div
            class="pageTitle cp"
            :class="chooseMenuId == item.id ? 'active' : ''"
            @click="chooseBtn(item.id)"
          >
            <div>{{ item.title }}</div>
            <div class="inline"></div>
          </div>
        </div>
      </div>
      <div>
        <!-- <el-button type="primary" @click="menuSet">导航设置</el-button> -->
        <el-button type="primary" @click="saveBtn">保存</el-button>
      </div>
    </div>
    <design-main class="design-main" />
    <menu-dialog ref="menuDialog" class="menu-dialog" />
  </div>
</template>
<script>
import menuDialog from "./components/menuDialog";
import designMain from "./components/designMain";
import { mapGetters } from "vuex";
export default {
  components: { menuDialog, designMain },
  computed: {
    ...mapGetters([
      "mubanInfo",
      "menuList",
      "chooseMenuId",
      "hasChanged",
      "templateList",
      "fullscreenLoading",
    ]),
  },
  methods: {
    chooseBtn(id) {
      if (this.hasChanged) {
        this.$confirm("该页面还没有保存，是否先保存?", "提示", {
          confirmButtonText: "保存并跳转",
          cancelButtonText: "不保存",
          type: "warning",
        })
          .then(() => {
            this.$store.commit("design/SET_LOADING", true);
            let obj = {
              id: this.mubanInfo.id,
              schoolPageMenuId: this.chooseMenuId,
              wxSchoolPageList: this.templateList,
            };
            this.api.wxSchoolPage
              .updateWxSchoolPageByTemplateId(obj)
              .then((res) => {
                this.$message.success("保存成功");
                this.$store.commit("design/HAS_CHANGED", false);
                this.$store.commit("design/SET_LOADING", false);
                this.$store.dispatch("design/setChooseId", id);
              });
          })
          .catch(() => {
            this.$store.dispatch("design/setChooseId", id);
          });
      } else {
        this.$store.dispatch("design/setChooseId", id);
      }
    },
    menuSet() {
      this.$refs.menuDialog.menuVisible = true;
    },
    saveBtn() {
      this.$store.commit("design/SET_LOADING", true);
      let obj = {
        id: this.mubanInfo.id,
        schoolPageMenuId: this.chooseMenuId,
        wxSchoolPageList: this.templateList,
      };
      this.api.wxSchoolPage.updateWxSchoolPageByTemplateId(obj).then((res) => {
        this.$message.success("保存成功");
        this.$store.commit("design/HAS_CHANGED", false);
        this.$store.commit("design/SET_LOADING", false);
      });
    },
  },
  mounted() {
    this.$store.dispatch("design/getMuban", this.$route.query.id);
  },
};
</script>
<style lang="less" scoped>
.design-page {
  background: #fff;
  height: 100%;
  .header {
    padding: 20px 10px 0 10px;
    border-bottom: 2px solid rgb(224, 222, 222);
    box-sizing: border-box;
    .el-tag {
      margin-right: 10px;
      margin-bottom: 10px;
    }
    .pageTitle {
      width: 80px;
      font-size: 14px;
      text-align: center;
      border-bottom: 2px solid #fff;
      padding-bottom: 10px;
      height: 45px;
      line-height: 45px;
      box-sizing: border-box;
    }
    .active {
      border-bottom: 2px solid rgb(0, 132, 255);
      color: rgb(0, 132, 255);
    }
    .el-button {
      margin-bottom: 10px;
    }
  }
  .design-main {
    height: calc(100% - 67px);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/design.vue